<template>
  <div>
    <div class="gpr-info actions" >
      <div class="action-statuses">
        <div class="lastAction">
          <div class="subheading">
            Last Action
          </div>
          <div class="title">
            {{getStatus("last")}}
          </div>
        </div>
        <div class="nextAction">
          <div class="subheading">
            Next Action
          </div>
          <div class="title">
            {{getStatus("next")}}
          </div>
        </div>
      </div>
      <md-progress-bar
        class="md-primary md-layout-item md-size-100 progress"
        md-mode="determinate"
        :md-value="progressAmt"
      ></md-progress-bar>

      <div class="next-button">
        <md-button class="md-sm md-info" @click="showProjectOverviewBox">View Project Overview</md-button>
        <div class="filler">
        </div>
        <md-button class="md-sm md-primary" @click="incrementActions" :disabled="lastAction == 10" v-if="gprAccess == true">Complete Next Action</md-button>
        <!-- <md-button class="md-sm md-primary"  @click="deleteProject" v-if="ifAdmin">Delete Project</md-button> -->
        <md-button class="md-sm md-primary"  @click="deleteProject" v-if="userInfo.email == 'jbutler@butlercoring.com'">Delete Project</md-button>
      </div>
      <div class="dialog-wrapper">
        <md-dialog :md-active.sync="showDialog">
          <div class="title-top md-dialog-title">
            <h4>Project Overview Timeline</h4>
            <md-icon v-on:click.native="showProjectOverviewBox">close</md-icon>
          </div>
          <ProjectOverview v-bind:project_statuses="project_statuses" />
        </md-dialog>
      </div>
    </div>

    <!-- <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 link-to-gpr">
      <template
        v-if="project.gpr_report.data !== null"
      >
        <md-button class="md-sm md-primary" @click="viewGPRReport">View GPR Report</md-button>
      </template>
      <router-link
        v-if="project.gpr_report.data === null && gprAccess == true"
        :to="{ name: 'GPR Report', params: { id: project.project.id }}"
      >
        <md-button class="md-sm md-primary">Start/Continue GPR Report</md-button>
      </router-link>
    </div>-->

  </div>
</template>
<script>
  import {ProjectOverview} from "@/pages/Dashboard/ProjectPages/Components/StatusProgress/Components";
  import api from "@/api";
  import idx from 'idx';

  export default {
    components: {
      ProjectOverview
    },
    props: ['project_statuses', 'projectId'],
    data() {
      return {
        lastAction: 0,
        nextAction: 1,
        showDialog: false,
        statuses: [],
        notAllowed: false,
        project: {
          project: {},
          project_statuses: [],
          ats_data: {},
          address: {},
          users: [],
          gpr_report: {},
          locations: [],
          ats_company: {},
        },
        userInfo: this.$store.state.user,
      }
    },
    created() {
      this.statuses = this.$store.state.statuses;
      var projectId = this.projectId;
      if (projectId == undefined) {
        this.$router.push("projectportal");
      } else {
        api.getProject(projectId).then((response) => {
          this.project = idx(response, _ => _.data);
          this.isLoading = false;
          var cu = this.$store.state.user
          var co = this.$store.state.company
          var cu_in_pu = this.project.users.filter((a) => a.id == cu.id)
          if (cu.gpr_access == true || cu.email == this.project.project_manager.email || cu_in_pu.length || co.id == this.project.ats_company.id){
            this.notAllowed = false;
          }
        }).catch((e) => {
          console.log(e)
        });
      }
    },
    mounted() {
      if (this.project_statuses && this.project_statuses.length > 0) {
        this.lastAction = this.project_statuses[this.project_statuses.length - 1].step;
        this.nextAction = this.project_statuses[this.project_statuses.length - 1].step + 1;
      }
    },
    methods: {
      showProjectOverviewBox() {
        this.showDialog = !this.showDialog;
      },
      incrementActions(){
        var status = this.statuses.filter((s) => s.step == this.nextAction)[0]
        var data = {
          project_id: this.projectId,
          action_to_add: status.id
        }
        api.advanceAction(data).then((response) => {
          if ((this.project_statuses[this.project_statuses.length - 1].step + 1) == response.data.status.step){
            this.lastAction = this.nextAction;
            this.nextAction = this.nextAction + 1;
            var newProjectStatus = this.project_statuses;
            newProjectStatus.push(response.data.status);
            this.$emit('update:project_statuses', newProjectStatus);
          } else {
            this.notifyVue('Something went wrong. Please refresh and try to complete the action again.', 'danger')
          }

        });
      },
      notifyVue(message, color) {
        // var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          // timeout: ,
          message: message,
          horizontalAlign: 'left',
          verticalAlign: 'top',
          type: color
        });
      },
      getStatus(action) {
        if (action == "last"){
          var status = this.statuses.filter((s) => s.step == this.lastAction);
          return status[0].finishedTitle
        } else if (action == "next") {
          var status = this.statuses.filter((s) => s.step == this.nextAction);
          return status[0].nextTitle;
        }
      },
      viewGPRReport(){
        this.$router.push(`/gprreportview/${this.project.project.id}`)
      },
      deleteProject() {
        if (confirm(`Are you sure you want to delete this project?`)) {
          api.deleteProject(this.projectId).then((response) => {
            this.notifyVue(`You have deleted this project`)
            this.$router.push(`/projectportal`)
          })
        }
      }
    },
    computed: {
      progressAmt: function() {
        var status = this.statuses.filter((s) => s.step == this.lastAction);
        return status[0].progress
      },
      gprAccess(){
        return this.$store.state.user.gpr_access;
      }
    }
  }
</script>
<style lang="scss" scoped>
  .md-dialog-container {
    // max-width: 768px;
    width: 80% !important;
  }
</style>
